import { render, staticRenderFns } from "./Sugestions.vue?vue&type=template&id=3478922b&"
import script from "./Sugestions.vue?vue&type=script&lang=js&"
export * from "./Sugestions.vue?vue&type=script&lang=js&"
import style0 from "./Sugestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports